export const AGREEMENT_STATE_ACCEPTED = 'ACCEPTED';

export const ACTIVE_AGREEMENT_STORAGE_KEY = 'mensis_active_agreement';
